import { Box, Button, Skeleton } from '@mui/material';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  api as authApi,
  useAuthLogoutMutation,
  useLazyUserCurrentQuery,
  useUserCurrentQuery,
} from '../../redux/services/auth/auth.generated';
import Login from '/public/icons/auth/login.svg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronDown from '/public/icons/chevron-down.svg';
import AccountSidebar from '../MyAccount/AccountSidebar';
import {
  api as PaymentsApi,
  usePaymentCancelSubscriptionMutation,
} from '../../redux/services/payments/payments.generated';
import { setNotification } from '../../redux/slices/notificationsSlice';
import { RenewalPolicyEnum } from '../../enums/UserCurrentEnums';
interface AuthDropDownProps {
  isGradientBackground: boolean;
  activeTab: string;
  breakpoint: boolean;
}
import UserIcon from '/public/icons/user.svg'; // Assuming you have a UserIcon component
import PersonIcon from '@mui/icons-material/Person';
import { praharTextColorSelector } from '../../redux/slices/praharSlice';

const AuthDropDown: FunctionComponent<AuthDropDownProps> = ({ breakpoint }) => {
  const specialGreyPages = [
    '/go-premium',
    '/gift',
    '/refunds-and-cancellations',
    '/terms-and-conditions',
    '/privacy-policy',
    '/disclaimer',
    '/redeem',
    '/for-artists',
  ];
  const dispatch = useDispatch();
  const router = useRouter();
  const currentPath = router.asPath.split('?')[0];
  const isSpecialGrey = specialGreyPages.includes(currentPath);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const praharTextColor = useSelector(praharTextColorSelector);
  const { asPath } = useRouter();
  const isPraharPage = asPath.includes('/prahar');
  const praharTextColorValue = isPraharPage ? praharTextColor : '#fff';

  const open = Boolean(anchorEl);

  const userToken = Cookies.get('ragya-token');
  // const {
  //   fetchUser,
  //   data: userData,
  //   refetch,
  //   isLoading,
  // } = useLazyUserCurrentQuery();

  const [fetchUser, { data: userData, isLoading }] = useLazyUserCurrentQuery();

  const [logoutMutation, logoutMutationResult] = useAuthLogoutMutation();
  const [cancelSubscriptionMutation, cancelSubscriptionMutationResult] =
    usePaymentCancelSubscriptionMutation();

  useEffect(() => {
    if (userToken) {
      fetchUser();
    }
  }, [userToken]);

  if (logoutMutationResult.data?.authLogout) {
    Cookies.remove('ragya-token');
    Cookies.remove('ragya-token', { path: '' });
    dispatch(authApi.util.resetApiState());
    window.location.reload();
  }

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setIsDrawerOpen(open);
    };
  if (
    cancelSubscriptionMutationResult?.isSuccess &&
    cancelSubscriptionMutationResult?.data.paymentCancelSubscription
      .renewalPolicy === RenewalPolicyEnum.cancelled.toString()
  ) {
    dispatch(
      setNotification({
        message: 'Subscription cancelled successfully',
        type: 'success',
      })
    );
    dispatch(PaymentsApi.util.resetApiState());
  }

  // It ensures that on mobile and when there’s no userData(user not logged in), the component renders nothing:
  // if (!breakpoint && !userData) {
  //   return null;
  // }

  const isSpecialTab =
    currentPath === '/prahar' ||
    currentPath === '/browse' ||
    currentPath === '/favourites';

  //check to hide on login page
  if (router.pathname === '/login') {
    return null;
  }

  return (
    <Box>
      <Button
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        disableRipple
        onClick={async (e) => {
          if (userData) {
            setIsDrawerOpen(true);
          } else {
            router.push({
              pathname: '/login',
              query: {
                previousPath: router.asPath,
              },
            });
          }
        }}
        sx={{
          // pr: breakpoint ? '10px' : '',
          // minWidth: '100px',
          '&:hover': {
            backgroundColor: 'transparent',
            color: isSpecialGrey
              ? (theme) => theme.ragyaPalette.gray5
              : 'white',
          },
          textTransform: 'none',
          color: isSpecialGrey
            ? (theme) => theme.ragyaPalette.gray8
            : praharTextColorValue,
        }}
        endIcon={
          breakpoint ? (
            isLoading || userData?.userCurrent.firstName ? (
              <ExpandMoreIcon />
            ) : (
              // <Login />
              <></>
            )
          ) : undefined // No endIcon on mobile
        }
      >
        {/* {!breakpoint ? (
          <Box
            sx={{
              display: 'flex',
              borderRadius: '25px',
              p: '10px',
              backgroundColor: isSpecialTab
                ? 'rgba(255,255,255,0.01)'
                : 'transparent', // your “else” default
              backdropFilter: isSpecialTab ? 'blur(15px)' : 'none', // your “else” default
            }}
          >
            <PersonIcon
              sx={{ filter: 'drop-shadow(0px 1px 3px rgba(0,0,0,0.25))' }}
            />
          </Box>
        ) : !isLoading ? (
          userData?.userCurrent.firstName ?? 'Sign in'
        ) : (
          <Skeleton sx={{ width: '100%' }} />
        )} */}

        {!breakpoint ? (
          !userData ? (
            <Button
              size='small'
              sx={{
                color: isSpecialGrey
                  ? (theme) => theme.ragyaPalette.gray8
                  : praharTextColorValue,
                borderRadius: '20px',
                textTransform: 'none',
                px: 2,
                py: '10px',
                backgroundColor: isSpecialTab
                  ? 'rgba(255,255,255,0.01)'
                  : 'transparent',
                backdropFilter: isSpecialTab ? 'blur(15px)' : 'none',
              }}
              onClick={() =>
                router.push({
                  pathname: '/login',
                  query: { previousPath: router.asPath },
                })
              }
            >
              Sign in
            </Button>
          ) : (
            <Box
              sx={{
                display: 'flex',
                borderRadius: '25px',
                p: '10px',
                backgroundColor: isSpecialTab
                  ? 'rgba(255,255,255,0.01)'
                  : 'transparent',
                backdropFilter: isSpecialTab ? 'blur(15px)' : 'none',
              }}
            >
              <PersonIcon
                sx={{
                  filter: isSpecialGrey
                    ? 'none'
                    : 'drop-shadow(0px 1px 3px rgba(0,0,0,0.25))',
                }}
              />
            </Box>
          )
        ) : !isLoading ? (
          <Box component='span' sx={{ fontWeight: 500 }}>
            {userData?.userCurrent.firstName ?? 'Sign in'}
          </Box>
        ) : (
          <Skeleton sx={{ width: '100%' }} />
        )}
      </Button>
      <AccountSidebar
        breakpoint={breakpoint}
        userData={userData}
        toggleDrawer={toggleDrawer}
        isDrawerOpen={isDrawerOpen}
        onLogout={() => logoutMutation()}
        onCancelSubscription={() =>
          cancelSubscriptionMutation({
            subscriptionId: userData?.userCurrent?.activeSubscription?.id || 0,
          })
        }
      />
    </Box>
  );
};

export default AuthDropDown;
